import type { Language } from "../context/i18n-context";

export const PUBLIC_LEGAL_ORIGIN = "https://disciplio.me";

export type PublicLegalDocument = "terms" | "privacy" | "cookies";

export function publicLegalUrl(document: PublicLegalDocument, language: Language) {
  const localePrefix = language === "pl" || language === "uk" ? `/${language}` : "";
  return `${PUBLIC_LEGAL_ORIGIN}${localePrefix}/${document}`;
}
